import Enums from 'utils/EnumsManager';

const { REPORT } = Enums.REDUX_ACTION_TYPE_PREFIX;
export const SET_SLOT_NAME = `${REPORT}_SET_SLOT_NAME`;
export const DELETE_SLOT = `${REPORT}_DELETE_SLOT`;
export const REVERT_SLOT = `${REPORT}_REVERT_SLOT`;
export const SET_GROUP_ORDER = `${REPORT}_SET_GROUP_ORDER`;
export const SET_SUMMARY_ORDER = `${REPORT}_SET_SUMMARY_ORDER`;
export const SET_GROUP_COLUMN = `${REPORT}_SET_GROUP_COLUMN`;
export const SET_SUMMARY_COLUMN = `${REPORT}_SET_SUMMARY_COLUMN`;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/flow/actionTypes.js